import { render, staticRenderFns } from "./TariffsOrder.vue?vue&type=template&id=343b2a62&"
import script from "./TariffsOrder.vue?vue&type=script&lang=js&"
export * from "./TariffsOrder.vue?vue&type=script&lang=js&"
import style0 from "./TariffsOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports